import React, { useEffect, useState } from "react";
import { api } from "@/api";
import { useTranslation } from "react-i18next";

function StatusBadge({ status, onChange, id }) {
  const styles = {
    pending: "border-amber-400/40 text-amber-400",
    confirmed: "border-emerald-400/40 text-emerald-400",
    cancelled: "border-red-400/40 text-red-400",
  };
  return (
    <select
      data-testid={`res-status-${id}`}
      value={status}
      onChange={(e) => onChange(e.target.value)}
      className={`bg-transparent border px-2 py-1 text-[10px] uppercase tracking-[0.2em] ${styles[status] || "border-[#D4AF37]/40 text-[#D4AF37]"}`}
    >
      <option className="bg-[#1A1A1A]" value="pending">pending</option>
      <option className="bg-[#1A1A1A]" value="confirmed">confirmed</option>
      <option className="bg-[#1A1A1A]" value="cancelled">cancelled</option>
    </select>
  );
}

export default function AdminReservations() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/reservations").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.patch(`/admin/reservations/${id}`, { status });
    load();
  };

  return (
    <div className="p-8 lg:p-12" data-testid="admin-reservations">
      <div className="overline">Back-office</div>
      <h1 className="font-serif-luxe text-4xl text-[#F8F5EF] mt-2 mb-8">{t("admin.reservations")}</h1>
      <div className="luxe-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="border-b border-[#D4AF37]/20">
            <tr className="text-left text-[10px] tracking-[0.22em] uppercase text-[#D4AF37]/80">
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Client</th>
              <th className="px-4 py-3">Téléphone</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Pers.</th>
              <th className="px-4 py-3">Message</th>
              <th className="px-4 py-3">Statut</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (<tr><td colSpan="7" className="px-4 py-10 text-center text-[#F8F5EF]/50">—</td></tr>)}
            {items.map(r => (
              <tr key={r.id} data-testid={`res-row-${r.id}`} className="border-b border-[#D4AF37]/10 hover:bg-[#D4AF37]/5">
                <td className="px-4 py-3 whitespace-nowrap">{r.date} · {r.time}</td>
                <td className="px-4 py-3">{r.first_name} {r.last_name}</td>
                <td className="px-4 py-3"><a href={`tel:${r.phone}`} className="hover:text-[#D4AF37]">{r.phone}</a></td>
                <td className="px-4 py-3"><a href={`mailto:${r.email}`} className="hover:text-[#D4AF37]">{r.email}</a></td>
                <td className="px-4 py-3 text-center">{r.guests}</td>
                <td className="px-4 py-3 max-w-xs truncate text-[#F8F5EF]/70">{r.message || "—"}</td>
                <td className="px-4 py-3"><StatusBadge id={r.id} status={r.status} onChange={(v) => updateStatus(r.id, v)} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
